<div class="configuration-dashboard-menu">
  <nav class="nav flex-column">
    <p class="navbar-verticle-label">Settings &amp; Configuration</p>
    <a *ngIf="permissionsService.canAccess('config_studio')" routerLink="/configuration/studio-information" routerLinkActive="active" class="nav-link" aria-current="page" title="Studio Information">
      <mat-icon>storefront</mat-icon> <span class="nav-text">Studio Information</span>
    </a>
    <a routerLink="/configuration/faq" routerLinkActive="active" class="nav-link" title="FAQ">
      <mat-icon>help_outline</mat-icon> <span class="nav-text">FAQ</span>
    </a>
    <a *ngIf="permissionsService.canAccess('config_studio')" routerLink="/configuration/tax-configuration" routerLinkActive="active" class="nav-link" title="Tax Configuration">
      <mat-icon>account_balance</mat-icon> <span class="nav-text">Tax Configuration</span>
    </a>
    <!-- Online Booking: restricted to administrators while the website embed is rolled out. -->
    <a *ngIf="permissionsService.has_access('view_admin_links') && permissionsService.canAccess('config_studio')" routerLink="/configuration/online-booking" routerLinkActive="active" class="nav-link" title="Online Booking">
      <mat-icon>event_available</mat-icon> <span class="nav-text">Online Booking</span>
    </a>
    <a *ngIf="permissionsService.canAccess('payments_manage_methods')" routerLink="/configuration/payment-configuration" routerLinkActive="active" class="nav-link" title="Payment Methods">
      <mat-icon>credit_card</mat-icon> <span class="nav-text">Payment Methods</span>
    </a>
    <!-- <a routerLink="/configuration/billing-portal" routerLinkActive="active" class="nav-link" title="Billing Portal">
      <mat-icon>payment</mat-icon> Billing Portal
    </a> -->
    <a *ngIf="permissionsService.canAccess('config_studio')" routerLink="/configuration/calendar-configuration" routerLinkActive="active" class="nav-link" title="Calendar Configuration">
      <mat-icon>calendar_today</mat-icon> <span class="nav-text">Calendar Configuration</span>
    </a>
    <!-- <a routerLink="/configuration" class="nav-link disabled">
      <mat-icon>history</mat-icon> Audit Trail
    </a> -->
  </nav>

  <nav class="nav flex-column" *ngIf="permissionsService.canAccess('staff_view')">
    <p class="navbar-verticle-label">Staff &amp; Payroll</p>
    <a routerLink="/configuration/staff-management" routerLinkActive="active" class="nav-link" title="Staff Management">
      <mat-icon>people</mat-icon> <span class="nav-text">Staff Management</span>
    </a>
    <a *ngIf="permissionsService.canAccess('staff_permissions')" routerLink="/configuration/permissions" routerLinkActive="active" class="nav-link" title="Permissions">
      <mat-icon>admin_panel_settings</mat-icon> <span class="nav-text">Permissions</span>
    </a>
    <a routerLink="/configuration" class="nav-link disabled" title="Payroll">
      <mat-icon>payments</mat-icon> <span class="nav-text">Payroll</span>
    </a>
    <a routerLink="/configuration" class="nav-link disabled" title="Communications">
      <mat-icon>chat</mat-icon> <span class="nav-text">Communications</span>
    </a>
  </nav>

  <nav class="nav flex-column" *ngIf="permissionsService.canAccess('config_studio')">
    <p class="navbar-verticle-label">Marketing &amp; Communications</p>
    <a routerLink="/configuration" class="nav-link disabled" title="Email Campaign">
      <mat-icon>campaign</mat-icon> <span class="nav-text">Email Campaign</span>
    </a>
    <a *ngIf="permissionsService.canAccess('gift_certificates_view')" routerLink="/configuration/gift-certificates" routerLinkActive="active" class="nav-link" title="Gift Certificates">
      <mat-icon>card_giftcard</mat-icon> <span class="nav-text">Gift Certificates</span>
    </a>
    <a routerLink="/configuration" class="nav-link disabled" title="Feedback & Surveys">
      <mat-icon>reviews</mat-icon> <span class="nav-text">Feedback &amp; Surveys</span>
    </a>
    <a routerLink="/configuration/communication-templates" routerLinkActive="active" class="nav-link" title="Communication Templates">
      <mat-icon>forum</mat-icon> <span class="nav-text">Communication Templates</span>
    </a>
  </nav>

  <nav class="nav flex-column" *ngIf="permissionsService.canAccess('config_import') || permissionsService.canAccess('config_export')">
    <p class="navbar-verticle-label">Import &amp; Data Migration</p>
    <ng-container *ngIf="permissionsService.canAccess('config_import')">
      <a (click)="toggleSimpleImport()" class="nav-link nav-link-toggle" style="cursor: pointer;" title="Simple Import">
        <mat-icon>file_download</mat-icon> <span class="nav-text">Simple Import</span>
        <mat-icon class="nav-chevron">{{ showSimpleImport ? 'expand_less' : 'expand_more' }}</mat-icon>
      </a>
      <div *ngIf="showSimpleImport">
        <a routerLink="/configuration/simple-import-instructors" routerLinkActive="active" class="nav-link nested-link" title="Import Instructors">
          <mat-icon>person</mat-icon> <span class="nav-text">Instructors</span>
        </a>
        <a routerLink="/configuration/simple-import-packages" routerLinkActive="active" class="nav-link nested-link" title="Import Packages">
          <mat-icon>local_offer</mat-icon> <span class="nav-text">Packages</span>
        </a>
        <a routerLink="/configuration/simple-import-student-accounts" routerLinkActive="active" class="nav-link nested-link d-none" title="Import Student Accounts">
          <mat-icon>school</mat-icon> <span class="nav-text">Student Accounts</span>
        </a>
        <a routerLink="/configuration/simple-import-history" routerLinkActive="active" class="nav-link nested-link d-none" title="Import History">
          <mat-icon>history</mat-icon> <span class="nav-text">History</span>
        </a>
        <a routerLink="/configuration/simple-import-spreadsheet" routerLinkActive="active" class="nav-link nested-link" title="Import Spreadsheet">
          <mat-icon>table_chart</mat-icon> <span class="nav-text">Spreadsheet</span>
        </a>
      </div>
      <a routerLink="/configuration/floatingrain-import" class="nav-link disabled" title="Floating Rain Import">
        <mat-icon>cloud_download</mat-icon> <span class="nav-text">Floating Rain Import</span>
      </a>
    </ng-container>
    <a *ngIf="permissionsService.canAccess('config_export')" routerLink="/configuration/export-backup" routerLinkActive="active" class="nav-link" title="Export / Backup">
      <mat-icon>backup</mat-icon> <span class="nav-text">Export / Backup</span>
    </a>
  </nav>

  <nav class="nav flex-column" *ngIf="permissionsService.canAccess('config_integrations')">
    <p class="navbar-verticle-label">Integrations</p>
    <!-- Temporarily restricted to super-admins while the QuickBooks
         integration is still being tested. Remove the *ngIf to re-open it. -->
    <a *ngIf="permissionsService.isSuperAdmin()" routerLink="/configuration/quickbooks-integration" routerLinkActive="active" class="nav-link" title="Quickbooks">
      <mat-icon>description</mat-icon> <span class="nav-text">Quickbooks</span>
    </a>
    <a routerLink="/configuration/stripe-integration" routerLinkActive="active" class="nav-link" title="Stripe">
      <i class="fa-brands fa-stripe-s"></i> <span class="nav-text">Stripe</span>
    </a>
    <a routerLink="/configuration/square-integration" routerLinkActive="active" class="nav-link" title="Square">
      <i class="fa-regular fa-square"></i> <span class="nav-text">Square</span>
    </a>
    <a routerLink="/configuration/paybright-integration" routerLinkActive="active" class="nav-link" title="PayBright">
      <mat-icon>point_of_sale</mat-icon> <span class="nav-text">PayBright</span>
    </a>
    <a routerLink="/configuration/stripe-twilio" routerLinkActive="active" class="nav-link" title="Twilio">
      <mat-icon>phone</mat-icon> <span class="nav-text">Twilio</span>
    </a>
  </nav>
</div>
